import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { ControlValueAccessor } from '@angular/forms';
import { Language } from 'app/model/constant';
import { RatingTitleModel } from 'app/model/rating/rating-title-model';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'act-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  @Input() data: RatingTitleModel;
  @Input() max: number;
  @Input() readOnly = false;
  @Output() hover = new EventEmitter<number>();
  @Output() leave = new EventEmitter<number>();
  @Output() rateChange = new EventEmitter<any>(true);

  private subscriptionLanguage: Subscription;

  private contexts = [];
  private rate: number;
  private nextRate: number;
  private ratingTitle: String;
  private ratingDesc: String;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private appConfigService: AppConfigService,
  ) {
    this.rate = 0;
    this.nextRate = 0;
  }

  ngOnInit() {
    this.subscriptionLanguage = this.appConfigService.getLanguageObs().subscribe((val) => {
      this.prepareData();
      this.updateRatingDesc(this.rate);
    });

    this.contexts = Array.from({ length: this.max }, (context, i) => ({
      selected: false,
      fraction: false,
      click: (e) => this.handleClick(e, i),
      enter: () => this.handleEnter(i)
    }));
    
    this.prepareData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['rate']) {
      this.update(this.rate);
    }
  }
  
  prepareData() {
    this.ratingTitle = this.appConfigService.getLanguage() === Language.th ? this.data.titleTH : this.data.titleEN;
  }

  updateRatingDesc(val: number) {
    this.ratingDesc = this.appConfigService.getTranslate('rating-star-' + val);
  }

  update(newRate: number, internalChange = true): void {
    if (!this.readOnly && this.rate !== newRate) {
      this.rate = newRate;
      this.rateChange.emit({
        id: this.data.ratingTitleId,
        rate: this.rate
      });
    }
    if (internalChange) {
      this.onChange(this.rate);
      this.onTouched();
    }
    this.updateState(this.rate);
  }

  /** Reset rate value */
  reset() {
    this.leave.emit(this.nextRate);
    this.updateState(this.rate);
  }

  private updateState(nextValue) {
    /** Set rate value as text */
    this.nextRate = nextValue - 1;
    /** Set the rating */
    this.contexts = Array.from({ length: this.max }, (context, index) => ({
      selected: index + 1 <= nextValue,
      fraction: (index + 1 === Math.round(nextValue) && nextValue % 1) >= 0.5,
      click: (e) => this.handleClick(e, index),
      enter: () => this.handleEnter(index)
    }));
    this.updateRatingDesc(nextValue);
  }

  private handleClick(e, value) {
    e.preventDefault();
    e.stopPropagation();
    this.update(value + 1);
  }

  private handleEnter(index) {
    if (!this.readOnly) {
      /** Add selected class for rating hover */
      this.contexts.map((context, i) => {
        context.active = i <= index;
        context.fraction = false;
        context.selected = false;
      });
      this.updateRatingDesc(index + 1);
      this.nextRate = index;
      this.hover.emit(index);
    }
  }

  /** This is the initial value set to the component */
  writeValue(value: number) {
    this.update(value, false);
    this.changeDetectorRef.markForCheck();
  }

  onChange = (_: any) => { };
  onTouched = () => { };

  registerOnChange(fn: (value: any) => any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => any): void {
    this.onTouched = fn;
  }
  
  ngOnDestroy() {
    this.subscriptionLanguage && this.subscriptionLanguage.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/star-rating/star-rating.component.ts